import React, { useEffect, useRef } from "react";
import SimActivationView from "../../../../../views/activationSales/components/simConnectivity/simActivationView";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
// import ExportToCsvButton from '../../../../../components/presentationals/ExportToCsvButton';
import { isEmptyObject, getJCJPIDs } from "../../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
// import simActivationData from '../data/data.json';
// import simActivationCsvData from '../data/sim-activation-csv.json';
import { simActivationCsvFilter } from "../../../../../utils/common/csvMappings/simConnectivityCsv";
import {
  fetchShowAlertActivation,
  hideAlertActivation,
} from "../../../../../redux/actions/activationSales";
import { triggerDashboardAudit } from "../../../../../redux/actions";

const SimActivation = (props) => {
  const dispatch = useDispatch();
  const { simActivationObj } = useSelector(
    (state) => state.activationSalesReducer
  );

  let {
    url,
    csvEndPointUrl,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    triggerSimActivationAPI,
    triggerSimActivationCsvAPI,
    triggerSimActivationJiophoneAPI,
    triggerSimActivationJiophoneCsvAPI,
    simJioPhoneData,
    section,
    moduleName,
  } = props;

  // const [downloadCsv, setDownloadCsv] = useState(false);
  // const endpointCsvData = simActivationCSVObj && simActivationCSVObj.simActivationCSVData;
  // const csvData = endpointCsvData && endpointCsvData[csvEndPointUrl];
  let { level, jioPointId, partnerRT, retailerId, id } =
    getJCJPIDs(filterValue);

  const PreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const headers = {
    id: id,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    partnerRoleType: partnerRT,
    section: props.section,
    moduleName: props.moduleName,
    jioPointId,
    retailerId,
    level,
    jprTypeName:
      filterValue.selectedCategory && filterValue.selectedCategory !== "ALL"
        ? filterValue.selectedCategory
        : "",
  };

  const pV = PreviousValue(filterValue);

  useEffect(() => {
    function fetchSimActivationJiophoneData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: simJioPhoneData?.tileEndPointUrl,
        },
        params: headers,
        extraData: simJioPhoneData?.tileEndPointUrl,
      };
      return dispatch(triggerSimActivationJiophoneAPI(obj));
    }
    function fetchSimActivationData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: headers,
        extraData: url,
      };
      return dispatch(triggerSimActivationAPI(obj));
    }
    if (isEmptyObject(simActivationObj && simActivationObj.simActivationData)) {
      fetchSimActivationData();
      fetchSimActivationJiophoneData();
    }
    if (
      pV &&
      pV.selectedCategory !== filterValue &&
      filterValue.selectedCategory
    ) {
      fetchSimActivationData();
      fetchSimActivationJiophoneData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    triggerSimActivationAPI,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    filterValue.selectedCategory,
  ]);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: moduleName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: section,
      },
    };
    triggerDashboardAudit(obj);
  };

  function csvHandlerJiophone(tab) {
    sendAudit();

    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: simJioPhoneData?.csvEndPointUrl,
      },
      params: Object.assign(headers, {
        brandDescr: tab?.split(" ")[0]?.toUpperCase(),
      }),
      // params: {
      //   "baseProcParameter": {
      //     "id": id,
      //     "partnerRoleType": partnerRT,
      //     "section": props.section,
      //     "moduleName": props.moduleName,
      //     "fromDate": "01-Jun-2021",
      //     "toDate": "30-Jun-2021",
      //     "jprTypeName": filterValue.selectedCategory && filterValue.selectedCategory !== "ALL"
      //       ? filterValue.selectedCategory
      //       : ""
      //   },
      //   "brandDescr": tab?.split(' ')[0]?.toUpperCase(),
      //   "jioPointId": jioPointId && jioPointId,
      //   "retailerId": retailerId && retailerId,
      //   "level": level && level
      // },
      extraData: simJioPhoneData?.csvEndPointUrl,
      tab: tab?.split(" ")[0]?.toUpperCase(),
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Mdn_SimActivation",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerSimActivationJiophoneCsvAPI(obj, (response, parmas) => {
        if (response?.content?.length) {
          const csvData = simActivationCsvFilter(
            props.filterValue.selectedPartnerRoleName,
            "JIOPHONE",
            response.content
          );
          csvData && csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertActivation());
          setTimeout(() => {
            dispatch(hideAlertActivation());
          }, 5000);
        }
      })
    );
  }

  function fetchSimActivationCsvData(tab) {
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: headers,
      extraData: csvEndPointUrl,
      tab: tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "Mdn_SimActivation",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerSimActivationCsvAPI(obj, (response, params) => {
        if (response?.content?.length) {
          // csvExporter.generateCsv(response.content);
          let csvData = simActivationCsvFilter(
            props.filterValue.selectedJC === ""
              ? props.filterValue.selectedPartnerRoleName
              : props.filterValue.selectedJC === "ALL"
              ? props.filterValue.selectedPartnerRoleName
              : "JP",
            props.tileName.split(" ")[0].toLowerCase(),
            response.content
          );
          csvData && csvExporter.generateCsv(response.content);
        } else {
          dispatch(fetchShowAlertActivation());
          setTimeout(() => {
            dispatch(hideAlertActivation());
          }, 5000);
        }
      })
    );
  }

  return (
    <SimActivationView
      csvName={props.csvName}
      isCsvActive={props.isCsvActive}
      csvHandlerJiophone={csvHandlerJiophone}
      fetchSimActivationCsvData={fetchSimActivationCsvData}
      section={section}
      moduleName={moduleName}
    />
  );
};

SimActivation.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerSimActivationAPI: PropTypes.func,
  triggerSimActivationCsvAPI: PropTypes.func,
};

export default SimActivation;
